import { useMemo, useEffect, useRef } from 'react'
import { useParams, useNavigate, useLocation } from 'react-router'
import { useSelector, useDispatch } from 'react-redux'
import { messagesActions, messagesSelectors } from 'store/messages'
import { ChatPageShell } from 'components/chat-page/ChatPageShell'
import { ChatMainArea } from 'components/chat-page/ChatMainArea'
import { getAreaIdSearchParams } from 'utils/query-params'
import { getMyChats } from 'api/chats'

export const ChatPage = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const { search } = useLocation()
  const { chatId: urlChatId } = useParams<{ chatId: string }>()
  const areaId = useMemo(getAreaIdSearchParams, [])
  const reduxChatId = useSelector(messagesSelectors.chatId)

  // Track if we're syncing to prevent loops
  const isSyncingRef = useRef(false)

  // Load chats on mount
  useEffect(() => {
    getMyChats({ areaId }).catch(console.error)
  }, [areaId])

  // Sync URL chatId to Redux on mount/URL change
  useEffect(() => {
    if (isSyncingRef.current) return

    if (urlChatId !== reduxChatId) {
      isSyncingRef.current = true
      dispatch(messagesActions.setChatId(urlChatId))
      // Reset sync flag after state update
      setTimeout(() => {
        isSyncingRef.current = false
      }, 0)
    }
  }, [urlChatId, dispatch])

  // Sync Redux chatId changes to URL (only for programmatic changes like openNewChat)
  useEffect(() => {
    if (isSyncingRef.current) return

    if (reduxChatId && reduxChatId !== urlChatId) {
      isSyncingRef.current = true
      navigate(`/chat/${reduxChatId}${search}`, { replace: true })
      setTimeout(() => {
        isSyncingRef.current = false
      }, 0)
    } else if (!reduxChatId && urlChatId) {
      isSyncingRef.current = true
      navigate(`/chat${search}`, { replace: true })
      setTimeout(() => {
        isSyncingRef.current = false
      }, 0)
    }
  }, [reduxChatId, search, navigate])

  return (
    <ChatPageShell>
      <ChatMainArea areaId={areaId} />
    </ChatPageShell>
  )
}
